import {
  browserTracingIntegration,
  dedupeIntegration,
  extraErrorDataIntegration,
  init,
  setUser,
} from '@sentry/react'

import { AuthenticatedUser } from 'modules/auth/authUser'
import { isProd } from 'utils/env'
import { formatName } from 'utils/format'

const SentryConfig = {
  dsn: 'https://e79a929897eb7c339a533ff7ac4912d6@o4508601944047696.ingest.de.sentry.io/4508602001064022',
  release: process.env.REACT_APP_RELEASE_COMMIT,
  environment: isProd() ? 'production' : 'development',
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
  ],
  tracesSampleRate: 1,
  integrations: [
    browserTracingIntegration(),
    dedupeIntegration(),
    extraErrorDataIntegration({ depth: 6 }),
  ],
  allowUrls: [/\.revolut\.(codes|com)/i],
}

export function setupSentry() {
  init(SentryConfig)
  setUser({
    email: AuthenticatedUser.email,
    username: formatName(AuthenticatedUser),
    permissions: AuthenticatedUser.permissions,
  })
}
